import * as React from 'react';
import { FormContext, getEmptyFilter } from "../context/Form";
import { Segment } from "./Segment";

export const Segments = () : JSX.Element => {
    const [data,dispatch] = React.useContext(FormContext);


    const addSegment = () => {
        const newData = {...data};

        newData.filter.push(getEmptyFilter());

        dispatch(
            {
                type: 'STORE',
                payload: {
                    data:newData
                },
            }
        );
    };

    return <div className={'c-segments'}>
        <h2>Doelgroepsegmenten</h2>
        { data.filter.map((value,index) => {
            return <Segment key={`segment_${index}`} filter={value} index={index} canDelete={data.filter.length > 1} />
        })}
        <button className={'c-segments__add-segment'} onClick={addSegment}>Segment toevoegen</button>
    </div>;
}
